module.exports = __webpack_public_path__ + "media/assets/fonts/Montserrat-Light-8c76b7212dc89231470116810c5d4af4.otf";